import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "news-list-content" }
const _hoisted_2 = { class: "main" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "left" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "details" }
const _hoisted_7 = { class: "auth" }
const _hoisted_8 = { class: "time" }
const _hoisted_9 = { class: "right" }

import NavBar from '@/components/NavBar.vue';
import Breadcrumb from '@/components/Breadcrumb.vue';
import Footer from '@/components/Footer.vue';
import { UtilMethods } from '@/util/UtilMethods';
import { BreadType, NewsType } from '@/typeDefine/EntityType';
import { Action } from '@/typeDefine/CommonTypes';
import { Api } from '@/http/Api';
import { onMounted, ref, Ref } from 'vue';
import { GetNewsListResponse } from '@/typeDefine/HttpResponseType';
import Pagination from '@/components/Pagination.vue';
import { ResponseCode } from '@/http/ResponseCode';
import { dayjs } from 'element-plus';
import { router } from '@/router';


export default /*@__PURE__*/_defineComponent({
  __name: 'NewsList',
  setup(__props) {

const maxZIndex: string = UtilMethods.getDOMStyleFromCSS('--max-z-index')

const breadList: BreadType[] = [
    {
        text: 'index.navBar.news'
    }
]

//当前页
const currentPage: Ref<number> = ref(1)
//页大小
const pageSize: Ref<number> = ref(10)
//总页数
const totalPage: Ref<number> = ref(0)

//新闻列表
const newsList: Ref<GetNewsListResponse['data']['news']> = ref([])

onMounted(() => requestNewsList(currentPage.value))

//请求新闻列表
const requestNewsList: Action<[number]> = async (currentPage: number) => {
    const response: GetNewsListResponse = await Api.instance.getNewsListByPage({
        startPage: currentPage
    })

    UtilMethods.showMessageToast(response,false)

    if(response.code === ResponseCode.OK) {
        newsList.value = response.data.news
        totalPage.value = response.data.totalPage

        console.log(response)
    }
}

const onPageChange: Action<[number]> = (value: number) => {
    requestNewsList(value)
}

//查看新闻详情
const goNewsDetails: Action<[id: number]> = (id) => {
    router.push({
        name: 'newsDetails',
        params: {
            id,
        }
    })
}


return (_ctx: any,_cache: any) => {
  const _component_el_affix = _resolveComponent("el-affix")!
  const _component_ArrowRightBold = _resolveComponent("ArrowRightBold")!
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_affix, { "z-index": _unref(maxZIndex) }, {
      default: _withCtx(() => [
        _createVNode(NavBar)
      ]),
      _: 1
    }, 8, ["z-index"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Breadcrumb, { "bread-list": breadList }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newsList.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "news-list pointer-cursor",
          key: index,
          onClick: ($event: any) => (goNewsDetails(item.id))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(item.title), 1),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('newsDetails.author')) + " ：" + _toDisplayString(item.author), 1),
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('newsDetails.createTime')) + "：" + _toDisplayString(_unref(UtilMethods).formatDataOfPattern(item.createTime,"YYYY/MM/DD")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_el_icon, {
              class: "icon",
              color: "#CECCCC",
              size: "30"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ArrowRightBold)
              ]),
              _: 1
            })
          ])
        ], 8, _hoisted_3))
      }), 128)),
      _createVNode(Pagination, {
        "current-page": currentPage.value,
        "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((currentPage).value = $event)),
        "page-size": pageSize.value,
        "total-page": totalPage.value,
        onCurrentPageChange: onPageChange,
        class: "page"
      }, null, 8, ["current-page", "page-size", "total-page"])
    ]),
    _createVNode(Footer)
  ]))
}
}

})